// Mesai Yönetimi - Sabitler ve Yapılandırma

import { BACKEND_URL, API } from '../../config';

export { BACKEND_URL, API };

export const priorityColors = {
  cok_yogun: { bg: 'bg-red-100', text: 'text-red-700', border: 'border-red-300', label: '🔴 Çok Yoğun', key: 'cok_yogun' },
  yogun: { bg: 'bg-orange-100', text: 'text-orange-700', border: 'border-orange-300', label: '🟠 Yoğun', key: 'yogun' },
  normal: { bg: 'bg-green-100', text: 'text-green-700', border: 'border-green-300', label: '🟢 Normal', key: 'normal' },
  az_yogun: { bg: 'bg-gray-100', text: 'text-gray-700', border: 'border-gray-300', label: '⚪ Az Yoğun', key: 'az_yogun' }
};

export const dayTypeLabels = {
  cumartesi: 'Cumartesi',
  pazar: 'Pazar',
  resmi_tatil: 'Resmi Tatil',
  idari_tatil: 'İdari Tatil',
  aksam_mesaisi: 'Akşam Mesaisi',
  gece_mesaisi: 'Gece Mesaisi',
  hafta_ici: 'Hafta İçi'
};

export const dayTypeColors = {
  cumartesi: 'bg-blue-100 text-blue-800',
  pazar: 'bg-blue-100 text-blue-800',
  resmi_tatil: 'bg-red-100 text-red-800',
  idari_tatil: 'bg-purple-100 text-purple-800',
  aksam_mesaisi: 'bg-orange-100 text-orange-800',
  gece_mesaisi: 'bg-indigo-100 text-indigo-800',
  hafta_ici: 'bg-gray-100 text-gray-800'
};

// Mesai atanabilecek roller (Migration 0064: cim_ekibi rolü kaldırıldı)
export const mesaiRoles = ['park_gorevlisi', 'formen', 'bolge_muhendisi'];

export const roleLabels = {
  park_gorevlisi: 'Park Görevlisi',
  formen: 'Formen',
  bolge_muhendisi: 'Bölge Mühendisi',
  mudur_yardimcisi: 'Müdür Yardımcısı',
  mudur: 'Müdür'
};

export const roleTitles = {
  'formen': 'Formen',
  'bolge_muhendisi': 'Bölge Müh.',
  'mudur_yardimcisi': 'Müd. Yrd.',
  'mudur': 'Müdür',
  'park_gorevlisi': 'Park Gör.'
};

// Yetki kontrolleri için roller
export const managerRoles = ['mudur', 'mudur_yardimcisi', 'bolge_muhendisi', 'formen'];
export const highLevelRoles = ['mudur', 'mudur_yardimcisi'];
export const supervisorRoles = ['formen', 'bolge_muhendisi'];
export const basicRoles = ['park_gorevlisi'];
